const moment = require('moment');
const {fsMomentImport} = require("../utils/utils");
const {ORDER_STATUS} = require("./OrderConstant");
const File = require("../file/File");
const Rental = require("../rental/Rental");

class Order {

    constructor({
                    id = '',
                    additionalID = {},
                    status = ORDER_STATUS.NEW,

                    customerID = '',
                    customer = null,
                    requestID = '',
                    request = null,
                    rental = null,
                    subRental = [],
                    invoiceID = [],
                    invoice = [],

                    created = moment(),
                    createdBy = '',
                    updated = moment(),
                    updatedBy = '',

                    file = [],
                } = {}) {


        this.id = id;
        this.additionalID = additionalID;
        this.status = ORDER_STATUS[status] ? status : ORDER_STATUS.NEW;

        this.customerID = customerID;
        this.customer = customer;
        this.requestID = requestID;
        this.request = request;
        this.rental = rental;
        this.subRental = Array.isArray(subRental) ? subRental : [];
        this.invoiceID = Array.isArray(invoiceID) ? invoiceID : [];
        this.invoice = Array.isArray(invoice) ? invoice : [];

        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.created = null;
        this.updated = null;
        const field = ['created', 'updated',];
        [created, updated].forEach((date, index) => {
            date = fsMomentImport(date)
            this[field[index]] = date && date.isValid() ? date : null

        })

        this.file = Array.isArray(file) ? file : [];
    }

    static get FS_COLLECTION_NAME() {
        return 'order'
    }

    static get ORDER_STATUS() {
        return ORDER_STATUS
    }

    validate(attribute) {

        if (attribute === undefined) {
            const attributes = Object.keys(this);
            try {
                attributes.map(attribute => {
                    if (!this._validate(attribute)) {
                        throw "validation error"
                    }
                });
            } catch (e) {
                return false
            }
            return true
        }

        return this._validate(attribute)
    }

    _validate(attribute) {

        try {
            switch (attribute) {
                case 'id':
                    return (typeof this[attribute] === 'string');
                default:
                    return false
            }
        } catch (e) {
            console.error('Validating Rental with error:', e, attribute);
            return false
        }
    }

    static fromRequest(request){
        return new Order({
            customerID: request.customerID,
            requestID: request.id,
            request: request,
            rental: request.selectedRental,
        })
    }

    toFirestore() {

       const subRental = {}, file = {}, carID = {[this.rental.carID]: true} // save carID in DB for query;

        try {
            this.file.forEach((f) => file[f.id] = f.toFirestore());
            this.subRental.forEach((r) => {
                carID[r.carID] = true // add all carID's of sub rentals
                subRental[r.id] = r.toFirestore()
            });
        } catch (e) {
            console.log('Could not convert files or sub rental')
        }

        return {
            id: this.id,
            additionalID: this.additionalID,
            status: this.status,

            customerID: this.customerID,
            requestID: this.requestID,
            rental: this.rental.toFirestore(),
            subRental,
            invoiceID: this.invoiceID,

            created: this.created && (typeof this.created.toDate === 'function') ? this.created.toDate() : null,
            createdBy: this.createdBy,
            updated: this.updated && (typeof this.updated.toDate === 'function') ? this.updated.toDate() : null,
            updatedBy: this.updatedBy,

            file,
            carID: Object.keys(carID),
        }
    }

    static parseFirestore(order, key, {invoice = {}, customer = {}, request = {}}) {
        const _invoice = [];

        order.invoiceID.forEach((id) => {
            if(invoice[id]){
                _invoice.push(invoice[id])
            }
        })

        return new Order({
            ...order,
            id: key ? key : order.id,
            customer: customer[order.customerID] ? customer[order.customerID] : null,
            request: request[order.requestID] ? request[order.requestID] : null,
            rental: Rental.parseFirestore(order.rental),
            subRental: Object.values(Rental.fromFirestore(order.subRental)),
            invoice: _invoice,
            file: order.file ? Object.values(File.fromFirestore(order.file)) : [],
        })
    }

    static fromFirestore(fsSnap, {invoice = {}, customer = {}, request = {}}) {

        let data = {};
        if (fsSnap) {
            Object.keys(fsSnap).forEach((key) => {
                // the firestore object is not null
                if (fsSnap[key]) {
                    data[key] = Order.parseFirestore({
                        ...fsSnap[key],
                        }, key, {invoice, customer, request})
                }
            });
        }

        return data
    }

    isSame(object) {

        return Object.is(
            JSON.stringify(object),
            JSON.stringify(this))
    }
}

module.exports = Order;